import React, { Dispatch, useMemo } from "react";

import { IgTextField, IgTypography } from "@intelligems/ig-theme";
import {
  StripeApiCouponDto,
  StripeApiGetAllCouponsResponseBodyType,
} from "@intelligems/ig-types";
import { Grid, Skeleton } from "@mui/material";
import { useStripeApi } from "@src/api/stripe/stripe-api";
import { VirtualAutoComplete } from "@src/components/VirtualAutoComplete/VirtualAutoComplete";
import { filterByNameOrId } from "@src/features/admin/components/Fields/filter-by-name-or-id";
import {
  CreateOrModifySubscriptionReducerType,
  CreateSubscriptionReducerAction,
} from "@src/features/admin/pages/overview/components/Drawers/SubscriptionDrawer/subscriptionReducer";

const Formatter = (data: StripeApiCouponDto) => {
  return (
    <Grid container columnSpacing={1} alignItems={"center"}>
      <Grid item>
        <IgTypography>{data.name}</IgTypography>
      </Grid>
    </Grid>
  );
};

interface ChooseCouponFieldProps {
  payload: CreateOrModifySubscriptionReducerType;
  dispatchPayload: Dispatch<CreateSubscriptionReducerAction>;
}

export const ChooseCouponField = ({
  payload,
  dispatchPayload,
}: ChooseCouponFieldProps) => {
  const coupons = useStripeApi<StripeApiGetAllCouponsResponseBodyType>({
    action: "getAllCoupons",
    orgs: payload.orgs,
  });

  const data: StripeApiCouponDto[] = useMemo(() => {
    if (!coupons.isSuccess) {
      return [];
    }
    return coupons.data.coupons;
  }, [coupons.isSuccess, coupons.data]);

  if (!coupons.isSuccess) {
    return <Skeleton variant="rectangular" height={40} />;
  }

  return (
    <Grid container item direction={"column"}>
      <Grid item>
        <IgTypography>Coupon</IgTypography>
      </Grid>
      <Grid item>
        <VirtualAutoComplete
          sx={{
            "& .MuiInputBase-root": {
              height: "40px",
            },
          }}
          formatter={Formatter}
          onChange={(e, newValue: StripeApiCouponDto) => {
            dispatchPayload({ type: "setCoupon", value: newValue });
          }}
          componentsProps={{
            paper: {
              sx: {
                "&.MuiPaper-root": {
                  width: "275px",
                },
              },
            },
            popper: {
              sx: {
                zIndex: 1800,
              },
            },
          }}
          isOptionEqualToValue={(option, value) => option.id === value?.id}
          options={data}
          getOptionLabel={(option: StripeApiCouponDto) => option.name}
          renderInput={(params) => (
            <IgTextField {...params} variant={"standard"} />
          )}
          value={payload.phases[payload.phaseIndex].coupon}
          filterOptions={filterByNameOrId}
        />
      </Grid>
    </Grid>
  );
};
